module.exports = __webpack_public_path__ + "img/logo.fb400f96.png";